"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PIX_WIX_URL = 'https://pix.wix.com/services';
exports.DEFAULT_PRIVATE_MEDIA_FOLDER_NAME = 'wix-vod';
exports.MAX_UPLOAD_FILE_SIZE = 26214400;
exports.MAX_IMAGE_UPLOAD_FILE_SIZE = 26214400;
//# sourceMappingURL=constants.js.map